// extracted by mini-css-extract-plugin
export default {"nav":"w8hrDE5Xo1qfg5c3jEmx","mainMenu":"w0tmDCZj3C_AltpF1UKR","link":"QySLqcA4SEA_Lrc5XdWc","active":"CmDvMurSG0x3VdhcF5My"};